var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3267 12.4002L4.8867 15.0002L3.53471 19.1872C3.31622 19.8366 3.31345 20.5392 3.52681 21.1903C3.74018 21.8414 4.15825 22.4061 4.7187 22.8002C5.26956 23.207 5.9371 23.4249 6.62186 23.4215C7.30662 23.418 7.97195 23.1935 8.51871 22.7812L11.9997 20.2192L15.4817 22.7782C16.0316 23.1827 16.6955 23.4023 17.3781 23.4057C18.0607 23.409 18.7267 23.1958 19.2805 22.7967C19.8342 22.3976 20.2472 21.8332 20.46 21.1847C20.6728 20.5361 20.6744 19.8368 20.4647 19.1872L19.1127 15.0002L22.6727 12.4002C23.2218 11.9987 23.6301 11.4339 23.8391 10.7866C24.048 10.1392 24.0471 9.44238 23.8364 8.79559C23.6257 8.14879 23.2159 7.58512 22.6657 7.1851C22.1155 6.78508 21.453 6.56917 20.7727 6.5682H16.3997L15.0727 2.4322C14.864 1.78116 14.454 1.21321 13.9017 0.810264C13.3494 0.407315 12.6834 0.190186 11.9997 0.190186C11.316 0.190186 10.65 0.407315 10.0977 0.810264C9.54544 1.21321 9.13538 1.78116 8.92671 2.4322L7.59971 6.5682H3.23071C2.55045 6.56917 1.8879 6.78508 1.33768 7.1851C0.787473 7.58512 0.377745 8.14879 0.167026 8.79559C-0.0436933 9.44238 -0.044626 10.1392 0.164361 10.7866C0.373348 11.4339 0.781566 11.9987 1.3307 12.4002H1.3267Z",
    fill: "#f9d645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBold);
export default __webpack_public_path__ + "static/media/startBold.6045dc3b29a71d2a225d9b52e5473e47.svg";
export { ForwardRef as ReactComponent };